var WDN__viewedProducts = (() => {
  var maxItemMemory = 20;
  var productHandleList = [];

  var readList = () => {
    if (localStorage.getItem('wdn__viewedProducts') && localStorage.getItem('wdn__viewedProducts').length > 0) {
      productHandleList = JSON.parse(localStorage.getItem('wdn__viewedProducts'));
    }

    return productHandleList;
  }

  var untrack = (handle) => {
    var foundIndex = productHandleList.indexOf(handle);
    if (foundIndex > -1) {
      productHandleList.splice(foundIndex, 1);
      saveToStorage();
    }
  }

  var saveToStorage = () => {
    if (productHandleList.length > maxItemMemory) {
      productHandleList.length = maxItemMemory;
    }

    localStorage.setItem("wdn__viewedProducts", JSON.stringify(productHandleList));
  }

  var track = (handle) => {
    if (handle && handle.length > 0) {
      if (productHandleList.indexOf(handle) > -1) {
        untrack(handle);
      }

      productHandleList.unshift(handle);
      saveToStorage();
    }
  }

  var clearHistory = () => {
    productHandleList = [];
    saveToStorage();
  }

  readList();

  return {
    list: readList,
    untrack: untrack,
    track: track
  }
})();